// Coordonnées réelles — DS Serrurier (raison sociale) / "DS Serrurier Urgence" (marque commerciale)
export const SITE = {
  // Marque commerciale (affichée partout dans le site)
  nom: "DS Serrurier Urgence",

  // Raison sociale (utilisée uniquement dans les mentions légales et JSON-LD legalName)
  raisonSociale: "DS Serrurier",

  telephone: "07 67 62 37 15",
  telephoneHref: "tel:+33767623715",
  email: "dsserrurier.idf@gmail.com",

  adresse: "Puteaux, 92800",
  codePostal: "92800",
  ville: "Puteaux",
  region: "Île-de-France",
  pays: "FR",

  // Service Area Business — pas d'accueil physique clientèle
  serviceAreaBusiness: true,

  siteUrl: "https://dsserrurier.fr",

  facebook: "https://www.facebook.com/profile.php?id=100063645604437",

  // Fiche Google Business Profile — lien stable par CID (0x39c4c5a20cc9f542)
  googleMaps: "https://maps.google.com/?cid=4162669255387116866",

  // Identifiants légaux
  siren: "979 002 078",
  siret: "979 002 078 00025",
  formeJuridique: "Micro-entreprise / Entreprise individuelle",
  activite: "Travaux de menuiserie métallique et serrurerie",

  horaires: "24h/24 · 7j/7",
};
